
export function Footer() {
  return (
    <footer id="contact" className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/7f238032a05683993a97bc96465f66ed/a554bab3c45cd373e1d11bc666f4c0d1.png" 
              alt="DJT DRONE AIRCRAFT" 
              className="h-20 md:h-24 w-auto object-contain mb-6 transition-transform duration-300 hover:scale-105"
            />
            <p className="text-lg font-light text-gray-300 mb-8 leading-relaxed">
              We pioneer sustainable air mobility to uplift quality of life. Experience the future of urban transportation with our all-electric drone aircraft solutions.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center hover:from-teal-400 hover:to-teal-500 transition-all transform hover:scale-110 cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center hover:from-blue-400 hover:to-blue-500 transition-all transform hover:scale-110 cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-br from-gray-700 to-gray-800 rounded-full flex items-center justify-center hover:from-gray-600 hover:to-gray-700 transition-all transform hover:scale-110 cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-full flex items-center justify-center hover:from-blue-500 hover:to-blue-600 transition-all transform hover:scale-110 cursor-pointer">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center hover:from-red-400 hover:to-red-500 transition-all transform hover:scale-110 cursor-pointer">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-teal-400">Solutions</h4>
            <ul className="space-y-3">
              <li><a href="#aircraft" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                Aircraft
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                DJT City
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                DJT Region
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                DJT IQ
              </a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-teal-400">Company</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                About Us
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                Career
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                Blog
              </a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center group cursor-pointer">
                <i className="ri-arrow-right-s-line text-teal-400 opacity-0 group-hover:opacity-100 transition-opacity mr-1"></i>
                FAQ
              </a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-teal-400">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-center text-gray-400">
                <i className="ri-phone-line text-teal-400 mr-3"></i>
                <a href="tel:1-800-570-0229" className="hover:text-white transition-colors cursor-pointer">1-800-570-0229</a>
              </li>
              <li className="flex items-center text-gray-400">
                <i className="ri-mail-line text-teal-400 mr-3"></i>
                <a href="mailto:info@djtdroneaircraft.com" className="hover:text-white transition-colors cursor-pointer">info@djtdroneaircraft.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter Section */}
        <div className="bg-gradient-to-r from-teal-500/10 to-blue-500/10 rounded-2xl p-8 mb-16 border border-teal-500/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-2xl font-semibold mb-2">Stay Updated</h3>
              <p className="text-gray-400">Subscribe to our newsletter for the latest updates on air mobility innovation.</p>
            </div>
            <div className="flex-1 max-w-md w-full">
              <div className="flex gap-3">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="flex-1 px-4 py-3 bg-white/10 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-teal-400 transition-colors"
                />
                <button className="px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-medium rounded-lg hover:from-teal-400 hover:to-teal-500 transition-all whitespace-nowrap cursor-pointer">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-wrap justify-center md:justify-start gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Legal Notice</a>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Cookie Settings</a>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">Terms of Service</a>
            </div>
            <p className="text-sm text-gray-400">
              Copyright © 2025 DJT DRONE AIRCRAFT. All rights reserved.
            </p>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 text-white rounded-full flex items-center justify-center hover:from-teal-400 hover:to-teal-500 transition-all shadow-2xl cursor-pointer z-40 transform hover:scale-110"
      >
        <i className="ri-arrow-up-line text-2xl"></i>
      </button>
    </footer>
  );
}
